import { baseApi } from "../../../../core/data/rtk/baseQuery";

export const studentTransferApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCenterTransfers: builder.query({
      query: ({ transferType = "outgoing", center_id, page = 1, size = 10 }) => ({
        url: `/student-transfers/center`,
        params: { transferType, center_id, page, size },
      }),
      providesTags: ["StudentTransfers"],
    }),
    revertTransfer: builder.mutation({
      query: (transferId) => ({
        url: `/student-transfers/revert/${transferId}`,
        method: "POST",
      }),
      invalidatesTags: ["StudentTransfers", "Students"],
    }),
  }),
});

export const { useGetCenterTransfersQuery, useRevertTransferMutation } = studentTransferApi;

